import { useMediaQuery } from '@material-ui/core';
import { Theme, useTheme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import LibraryFilter from './components/filter/LibraryFilter';

type InputChangeHandler = (value: string | null) => void;

export interface Props {
  onFilterValueChange: InputChangeHandler;
  initialFilterValue: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-end',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(3)
    }
  },
  searchFilter: {
    [theme.breakpoints.down('sm')]: {
      flexGrow: 0
    },
    [theme.breakpoints.up('sm')]: {
      flexGrow: 2
    }
  },
  spacer: {
    flexGrow: 25
  }
}));

export const LibrarySearch = (props: Props) => {
  const { onFilterValueChange, initialFilterValue } = props;

  const initialValue = initialFilterValue || '';

  const classes = useStyles();
  const theme = useTheme();
  const showMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const libraryFilter = (
    <div className={classes.searchFilter}>
      <LibraryFilter onValueChange={onFilterValueChange} initialValue={initialValue} />
    </div>
  );

  const fullView = (
    <div className={classes.container} >
      <div className={classes.spacer} />
      {libraryFilter}
    </div>
  );

  const mobileView = (
    <div className={classes.container} >
      {libraryFilter}
    </div>
  );

  return showMobileView ? mobileView : fullView;
};
